import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern } from '../../../shared/constants';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-question-form',
	templateUrl: './question-form.component.html',
	styleUrl: './question-form.component.css'
})
export class QuestionFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	allProfiles: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			profile: [null, [Validators.required]],
			name: [null, [Validators.required]],
			questions: this.formBuilder.array([])
		});
	}

	ngOnInit(): void {
		this.getProfileList();
		if (this.uId) {
			this.getDetails();
		} else {
			this.addRow()
			this.f.name.clearValidators();
			this.f.name.setValidators(null);
			this.f.name.updateValueAndValidity();
		}
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['questions'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			question_name: [null, [Validators.required]]
		});
		this.get_rows.push(form);
	}

	deleteRow(index: number) {
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
	}

	getProfileList() {
		this.apiService.getAllProfileList().subscribe({
			next: (data: any) => {
				this.allProfiles = data;
			}, error: (error) => {
				this.allProfiles = [];
				this.toastr.error("Unable to fetch parent scale list.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	deselectById(id: any) {
		var arr: any = this.f.scale.value;
		const index = arr.indexOf(id);
		arr.splice(index, 1);
		arr = [...arr];
		this.f.scale.setValue(arr);
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getQuestionDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.profile.setValue(data.profile);
				this.f.name.setValue(data.name);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}

		let data: any = {
			"profile": this.f.profile.value
		}
		if (!this.uId) {
			let questions: any = [];
			for (let i = 0; i < this.get_rows.controls.length; i++) {
				questions.push({ question_name: this.get_rows.controls[i].get("question_name")?.value });
			}
			data.questions = questions;
		} else {
			data.name = this.f.name.value;
			data.id = this.uId;
		}
		/* let payload: any = {
			"data": data,
			"id": this.uId
		} */
		this.showLoader = true;
		this.apiService.createUpdateQuestion(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true,
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}
}
